(function($) {
  /* ==== WooCommerce - Billing/Shipping Addresses ==== */
  if ($('.imedia-wc-delete-address').length) {
    $('.imedia-wc-delete-address').each(function () {
      var errorMessage = $(this).parent().parent().find('.address__error');

      /**
       * Delete Button - Click Handler
       */
      $(this).click(function(e) {
        e.preventDefault();

        errorMessage.hide();

        $.ajax({
          url: ajax_object.ajaxurl,
          type: 'POST',
          data: {
            action: 'ajax_action_imedia_wc_delete_address',
            type: $(this).attr('data-type'),
          },
          success: function (response) {
            location.reload();
          },
          error: function (response) {
            console.log('Error: ' + response.responseJSON.message);
            errorMessage.show();
          },
        });
      });
    });
  }
})(jQuery);